import {createContext} from 'react'
import {useMediaQuery} from 'react-responsive'
import {useLocalStorage} from 'react-use'
import {BodyClassName} from 'react-html-body-classname'

export interface IDarkModeContextWrapperProps {
  children: React.ReactNode
}

export interface IDarkModeContext {
  systemPrefersDarkMode: boolean
  userPrefersDarkMode: boolean
  setUserPrefersDarkMode: (value: boolean) => void
  toggle: () => void
}

export const DarkModeContext = createContext<IDarkModeContext>({
  systemPrefersDarkMode: false,
  userPrefersDarkMode: false,
  setUserPrefersDarkMode: () => {
    throw new Error('not implemented')
  },
  toggle: () => {
    throw new Error('not implemented')
  },
})

export function DarkModeContextWrapper(props: IDarkModeContextWrapperProps) {
  const {children} = props

  const systemPrefersDarkMode = useMediaQuery(
    {
      query: '(prefers-color-scheme: dark)',
    },
    undefined
  )

  const [userPrefersDarkMode, setUserPrefersDarkMode] = useLocalStorage(
    'userPrefersDarkMode',
    systemPrefersDarkMode
  )

  function toggle() {
    setUserPrefersDarkMode(!userPrefersDarkMode)
  }

  return (
    <DarkModeContext.Provider
      value={{
        systemPrefersDarkMode,
        userPrefersDarkMode: userPrefersDarkMode || false,
        setUserPrefersDarkMode,
        toggle,
      }}
    >
      <BodyClassName
        id='dark-mode'
        className={userPrefersDarkMode ? 'dark' : ''}
      >
        {children}
      </BodyClassName>
    </DarkModeContext.Provider>
  )
}
